import {Injectable} from '@angular/core';
import {FascicoloFull} from "../../../common/models/fascicolo/fascicolo-full";
import {RowSezione} from "../../../common/models/fascicolo/row-sezione";
import {VoceSezione} from "../../../common/models/fascicolo/voce-sezione";
import {OperationsService} from '../../../core/services/operations.service';
import {
  FascicoloRicorsoLavoro
} from '../../../lavoro/fascicoloFormShared/models/ricorso-lavoro/fascicolo-ricorso-lavoro';
import {FormAppelloComponent} from "../form-appello/form-appello.component";
import {FormAppelloViewComponent} from "../form-appello/view/form-appello-view.component";
import {FormOpposizioneDiTerzoComponent} from "../form-opposizione-di-terzo/form-opposizione-di-terzo.component";
import {
  FormOpposizioneDiTerzoViewComponent
} from "../form-opposizione-di-terzo/view/form-opposizione-di-terzo-view.component";
import {FormOrdinarioComponent} from "../form-ordinario/form-ordinario.component";
import {FormOrdinarioViewComponent} from "../form-ordinario/view/form-ordinario-view.component";
import {
  FormRecuperoCreditiStragiudizialeComponent
} from "../form-recupero-crediti-stragiudiziale/form-recupero-crediti-stragiudiziale.component";
import {
  FormRecuperoCreditiStragiudizialeViewComponent
} from "../form-recupero-crediti-stragiudiziale/view/form-recupero-crediti-stragiudiziale-view.component";
import {FormRevocazioneComponent} from "../form-revocazione/form-revocazione.component";
import {FormRevocazioneViewComponent} from "../form-revocazione/view/form-revocazione-view.component";
import {FormRicorsoGerarchicoComponent} from "../form-ricorso-gerarchico/form-ricorso-gerarchico.component";
import {
  FormRicorsoGerarchicoViewComponent
} from "../form-ricorso-gerarchico/view/form-ricorso-gerarchico-view.component";
import {FormRicorsoLavoroComponent} from '../form-ricorso-lavoro/form-ricorso-lavoro.component';
import {FormRicorsoLavoroViewComponent} from '../form-ricorso-lavoro/view/form-ricorso-lavoro-view.component';
import {FormRicorsoOpposizioneComponent} from "../form-ricorso-opposizione/form-ricorso-opposizione.component";
import {
  FormRicorsoOpposizioneViewComponent
} from "../form-ricorso-opposizione/view/form-ricorso-opposizione-view.component";
import {
  FormRicorsoStraordinarioPresidenterepComponent
} from "../form-ricorso-straordinario-presidenterep/form-ricorso-straordinario-presidenterep.component";
import {
  FormRicorsoStraordinarioPresidenterepViewComponent
} from "../form-ricorso-straordinario-presidenterep/view/form-ricorso-straordinario-presidenterep-view.component";
import {FormRicorsoAmministrativoComponent} from '../form-ricorso/form-ricorso.component';
import {FormRicorsoAmministrativoViewComponent} from '../form-ricorso/view/form-ricorso-view.component';
import {FormSpecialeComponent} from "../form-speciale/form-speciale.component";
import {FormSpecialeViewComponent} from "../form-speciale/view/form-speciale-view.component";
import {FascicoloAppello} from "../models/appello/fascicolo-appello";
import {FascicoloOpposizioneDiTerzo} from "../models/opposizione-di-terzo/fascicolo-opposizione-di-terzo";
import {FascicoloOrdinario} from "../models/ordinario/fascicolo-ordinario";
import {
  FascicoloRecuperoCreditiStragiudiziale
} from "../models/recupero-crediti-stragiudiziale/fascicolo-recuperocreditistragiudiziale";
import {FascicoloRevocazione} from "../models/revocazione/fascicolo-revocazione";
import {FascicoloRicorsoGerarchico} from "../models/ricorso-gerarchico/fascicolo-ricorsogerarchico";
import {FascicoloRicorsoOpposizione} from "../models/ricorso-opposizione/fascicolo-ricorso-opposizione";
import {
  FascicoloRicorsoStraordinarioPresidenteRep
} from "../models/ricorso-straordinario-presidenterep/fascicolo-ricorsostraordinario-presidenterep";
import {FascicoloRicorsoAmministrativo} from '../models/ricorso/fascicolo-ricorso';
import {FascicoloSpeciale} from '../models/speciale/fascicolo-speciale';
import {FascicoloGenerico} from '../models/generico/fascicolo-generico';
import {FormGenericoViewComponent} from '../form-generico/view/form-generico-view.component';
import {FormGenericoComponent} from '../form-generico/form-generico.component';

@Injectable({
  providedIn: 'root'
})

export class FascicoloService {

  constructor(private ops: OperationsService) {
  }

  getFascicolo(genericFascicolo): any {
    let fascicolo;
    switch (genericFascicolo) {
      case 'ricorsostraordinariopresidente': {
        fascicolo = new FascicoloRicorsoStraordinarioPresidenteRep();
        break;
      }
      case 'ricorsogerarchico': {
        fascicolo = new FascicoloRicorsoGerarchico();
        break;
      }
      case 'ricorsoopposizione': {
        fascicolo = new FascicoloRicorsoOpposizione();
        break;
      }
      case 'appello': {
        fascicolo = new FascicoloAppello();
        break;
      }
      case 'revocazione': {
        fascicolo = new FascicoloRevocazione();
        break;
      }
      case 'opposizionediterzo': {
        fascicolo = new FascicoloOpposizioneDiTerzo();
        break;
      }
      case 'ricorsoamministrativo':
      case 'ricorsotar': {
        fascicolo = new FascicoloRicorsoAmministrativo();
        break;
      }
      case 'recuperocreditistragiudiziale': {
        fascicolo = new FascicoloRecuperoCreditiStragiudiziale();
        break;
      }
      case 'ordinario': {
        fascicolo = new FascicoloOrdinario();
        break;
      }
      case 'speciale': {
        fascicolo = new FascicoloSpeciale();
        break;
      }
      case 'ricorso':
      case 'ricorsolavoro': {
        fascicolo = new FascicoloRicorsoLavoro();
        break;
      }
      case 'genericogiudiziale': {
        fascicolo = new FascicoloGenerico();
        break;
      }
    }
    return fascicolo;
  }

  getComponentFromFormTenant(idFormTenant, view = false) {
    let component;
    switch (idFormTenant) {
      case 'AmmRsp_PRD': {
        component = view ? FormRicorsoStraordinarioPresidenterepViewComponent : FormRicorsoStraordinarioPresidenterepComponent; // "RICORSO STRAORDINARIO AL PRESIDENTE DELLA REPUBBLICA",
        break;
      }
      case 'AmmRge_PRD': {
        component = view ? FormRicorsoGerarchicoViewComponent : FormRicorsoGerarchicoComponent; // "RICORSO GERARCHICO",
        break;
      }
      case 'AmmRop_PRD': {
        component = view ? FormRicorsoOpposizioneViewComponent : FormRicorsoOpposizioneComponent; // "RICORSO IN OPPOSIZIONE",
        break;
      }
      case 'AmmApp_PRD': {
        component = view ? FormAppelloViewComponent : FormAppelloComponent; // "APPELLO",
        break;
      }
      case 'AmmRev_PRD': {
        component = view ? FormRevocazioneViewComponent : FormRevocazioneComponent; // "REVOCAZIONE",
        break;
      }
      case 'AmmOdt_PRD': {
        component = view ? FormOpposizioneDiTerzoViewComponent : FormOpposizioneDiTerzoComponent; // "OPPOSIZIONE DI TERZO",
        break;
      }
      case 'AmmRat_PRD': {
        component = view ? FormRicorsoAmministrativoViewComponent : FormRicorsoAmministrativoComponent; // "RICORSO AMMINISTRRATIVO";
        //component = view ? FormRicorsoAlTarViewComponent : FormRicorsoAlTarComponent; // "RICORSO AL TAR",
        break;
      }
      case 'AmmRec_PRD': {
        component = view ? FormRecuperoCreditiStragiudizialeViewComponent : FormRecuperoCreditiStragiudizialeComponent; // "RECUPERO CREDITI STRAGIUDIZIALE",
        break;
      }
      case 'AmmOrd_PRD': {
        component = view ? FormOrdinarioViewComponent : FormOrdinarioComponent; // "ORDINARIO";
        break;
      }
      case 'AmmSpe_PRD': {
        component = view ? FormSpecialeViewComponent : FormSpecialeComponent; // "SPECIALE";
        break;
      }
      case 'AmmRic_PRD': {
        component = view ? FormRicorsoLavoroViewComponent : FormRicorsoLavoroComponent; // "RICORSO";
        break;
      }
      case 'AmmGen_PRD': {
        component = view ? FormGenericoViewComponent : FormGenericoComponent; // "GENERICO";
        break;
      }
    }
    return component;
  }

  getMappaCopertinaFascicolo(genericFascicolo: string, fascicolo: FascicoloFull, viewComponentDynamic?: string, assegnatario?: string): RowSezione[] {
    // todo: ottimizzare funzione + gestire viewComponentDynamic;
    let esiti = this.getEsitiFromCopertina(fascicolo);
    let udienzeEsiti = this.getUdienzeEsitiFromCopertina(fascicolo);
    switch (genericFascicolo) {
      case 'ricorsostraordinariopresidente': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(6, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Parte primaria (n. controparti)', (fascicolo.copertina.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '') + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null ? ' di ' + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria) : '')),
            new VoceSezione(4, 'text', 'Valore', fascicolo.copertina.campi.valore)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),          
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'ricorsogerarchico': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(6, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Parte primaria (n. controparti)', (fascicolo.copertina.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '') + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null ? ' di ' + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria) : '')),
            new VoceSezione(4, 'text', 'Valore', fascicolo.copertina.campi.valore)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'ricorsoopposizione': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(6, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Parte primaria (n. controparti)', (fascicolo.copertina.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '') + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null ? ' di ' + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria) : '')),
            new VoceSezione(4, 'text', 'Valore', fascicolo.copertina.campi.valore)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Opposizione', [
            new VoceSezione(12, 'text', 'Motivo opposizione', fascicolo.copertina.campi.motivoOpposizione),
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'appello': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data deposito ricorso', fascicolo.dataDepositoRicorso)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'revocazione': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data deposito ricorso', fascicolo.dataDepositoRicorso)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'opposizionediterzo': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(6, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Parte primaria (n. controparti)', (fascicolo.copertina.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '') + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null ? ' di ' + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria) : '')),
            new VoceSezione(4, 'text', 'Valore', fascicolo.copertina.campi.valore)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'ricorsoamministrativo':
      case 'ricorsotar': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(6, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'recuperocreditistragiudiziale': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(6, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Parte primaria (n. controparti)', (fascicolo.copertina.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))
          ]),
          new RowSezione('Diffida', [
            new VoceSezione(4, 'text', 'Ultima lettera diffida (numero invii)',
              (fascicolo.copertina.campi.tipoUltimaLetteraDiffida ? (fascicolo.copertina.campi.tipoUltimaLetteraDiffida +
                ' (' + (fascicolo.copertina.campi.numeroInviiDiffida ? fascicolo.copertina.campi.numeroInviiDiffida : '0') + ')') : '')),
            new VoceSezione(4, 'date', 'Data ultima diffida', fascicolo.copertina.campi.dataUltimaLetteraDiffida),
            new VoceSezione(4, 'text', 'Esito ultimo invio', fascicolo.copertina.campi.esitoUltimoInvioDiffida)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'ordinario':
      case 'genericogiudiziale': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data deposito ricorso', fascicolo.dataDepositoRicorso)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'speciale': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data ultima modifica', fascicolo.copertina.campi.dataUltimaModifica),
            new VoceSezione(4, 'text', 'Stato', fascicolo.copertina.campi.stato)
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data definizione', fascicolo.copertina.campi.dataDefinizione),
            new VoceSezione(6, 'text', 'Motivo definizione', fascicolo.copertina.campi.motivoDefinizione),
            //new VoceSezione(4, 'boolean', 'Fondo rischi', fascicolo.copertina.campi.fondoRischi)
          ]),
          new RowSezione(((fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? 'Riunione dei giudizi' : ''), (fascicolo.copertina.campi.capofila || fascicolo.copertina.campi.riunito) ? [
            new VoceSezione(4, 'text', fascicolo.copertina.campi.capofila ? 'Capofila' : 'Riunito', 'Si'),
            new VoceSezione(4, 'date', 'Data riunione giudizio', fascicolo.copertina.campi.dataRiunioneGiudizio),
            new VoceSezione(4, 'text', 'Motivo riunione giudizio', fascicolo.copertina.campi.motivoRiunioneGiudizio)
          ] : [new VoceSezione(12, '', '', '')]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Parte primaria (n. controparti)', (fascicolo.copertina.campi.contropartePrimaria) + (' (' + fascicolo.copertina.campi.numeroControparti + ')')),
            //new VoceSezione(4, 'text', 'Legale incaricato', (fascicolo.copertina.campi.legaleIncaricato ? fascicolo.copertina.campi.legaleIncaricato : '') + (fascicolo.copertina.campi.tipologiaDiLegaleIncaricato ? ' (' + fascicolo.copertina.campi.tipologiaDiLegaleIncaricato + ')' : '')),
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'text', 'Visibilità', fascicolo.tipoVisibilita?.label ? fascicolo.tipoVisibilita?.label : (fascicolo.praticaBase.tipoVisibilita?.label ? fascicolo.praticaBase.tipoVisibilita?.label : null))
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '') + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria != null ? ' di ' + (fascicolo.copertina.campi.sedeAutoritaGiudiziaria) : '')),
            new VoceSezione(4, 'text', 'Valore', fascicolo.copertina.campi.valore)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'ricorso':
      case 'ricorsolavoro': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione('Dati Giudiziari', [
            new VoceSezione(4, 'text', 'Autorit&agrave; giudiziaria', (fascicolo.copertina.campi.autoritaGiudiziaria ? fascicolo.copertina.campi.autoritaGiudiziaria : '')),
            new VoceSezione(4, 'text', 'Sede', fascicolo.copertina.campi.sedeAutoritaGiudiziaria),
            new VoceSezione(4, 'text', 'Grado', (fascicolo.copertina.campi.grado ? fascicolo.copertina.campi.grado : '')),
            new VoceSezione(6, 'text', 'Numero/anno ruolo', (fascicolo.copertina.campi.numeroRuolo ? fascicolo.copertina.campi.numeroRuolo : '') + (fascicolo.copertina.campi.numeroRuolo && fascicolo.copertina.campi.annoRuolo ? '/' : '') + (fascicolo.copertina.campi.annoRuolo ? fascicolo.copertina.campi.annoRuolo : '')),
            new VoceSezione(6, 'text', 'Sezione', fascicolo.copertina.campi.sezione)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data notifica', fascicolo.dataNotifica),
            new VoceSezione(4, 'date', 'Data deposito ricorso', fascicolo.dataDepositoRicorso)
          ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Costituzione SI/NO', true === fascicolo.flagCostituzione ? 'Si' : 'No'),
            new VoceSezione(4, 'text', 'Motivazione', fascicolo.motivazione ? fascicolo.motivazione.label : ''),
            new VoceSezione(4, 'date', 'Data costituzione', fascicolo.dataCostituzione)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
    }
  }

  getEsitiFromCopertina(fascicolo: FascicoloFull): any[]{
    let listaVoci = [];
    if (fascicolo.copertina.campi.esiti) {
      for (let esito of fascicolo.copertina.campi.esiti) {
        listaVoci.push(new VoceSezione(3, "text", "Esito", esito.esitoPerSocieta));
        listaVoci.push(new VoceSezione(3, "text", "Tipo", esito.tipoSentenza));
        listaVoci.push(new VoceSezione(3, "text", "Numero/Anno", esito.numeroSentenza));
        listaVoci.push(new VoceSezione(3, "text", "Risoluzione per parte", esito.esitoRisoluzioneParte));
      }
    }
    return listaVoci;
  }
  getUdienzeEsitiFromCopertina(fascicolo: FascicoloFull): any[] {
    let listaVoci = [];
    if (fascicolo.copertina.campi.scadenze) {
      for (let i = 0; i < fascicolo.copertina.campi.scadenze.length; i++) {
        let esitoUdienza = fascicolo.copertina.campi.scadenze[i];    
        listaVoci.push(new VoceSezione(4, "text", "Adempimento", esitoUdienza.tipoAdempimento ?? ""));
        listaVoci.push(new VoceSezione(4, "date", "Data udienza", esitoUdienza.dataUdienza ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Tipo provvedimento", esitoUdienza.tipoEsito ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Numero/Anno esito", esitoUdienza.numeroAnnoEsito ?? ""));
        listaVoci.push(new VoceSezione(4, "date", "Data pubblicazione", esitoUdienza.dataPubblicazione ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Esito", esitoUdienza.esito ?? ""));
        listaVoci.push(new VoceSezione(12, "text", "Note udienza", esitoUdienza.noteUdienza ?? ""));    
        // Aggiungi il divider solo se ci sono almeno due elementi e NON per l'ultima iterazione
        if (fascicolo.copertina.campi.scadenze.length > 1 && i < fascicolo.copertina.campi.scadenze.length - 1) {
          listaVoci.push(new VoceSezione(12, "divider", "", ""));
        }
      }
    }     
    return listaVoci;
  }


}
